<template>
  <div>
    <theme-activity></theme-activity>
  </div>
</template>
<script>
export default {
  components: { ThemeActivity: () => import("@/components/ThemeActivity") },
};
</script>